import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import data from '../../data/countries.json';
import loadScripts from '../../../dassets/js/custom';
class OtherInfo extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.selectCountry = this.selectCountry.bind(this);
        this.countries = data.countries;
        this.nationalities = data.nationalities;
        this.state = {
            states: []
        }
    }

    selectCountry(e) {
        let states = this.countries.find(x => x.name === e.target.value).states;
        this.setState({
            states: states
        })
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            residential_add: this.refs.residential_add.value,
            contact_add: this.refs.contact_add.value,
            country: this.refs.country.value,
            nationality: this.refs.nationality.value,
            state_of_origin: this.refs.state_of_origin.value,
            city_lga: this.refs.city_lga.value,
        }

        this.props.saveValues(data)
        this.props.nextStep()
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Other Information</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Residential Address<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="residential_add" placeholder="Residential Address"
                                                defaultValue={this.props.fieldValues.residential_add} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Contact Address</label>
                                            <Form.Control type="text" className="form-control" ref="contact_add" placeholder="Contact Address" defaultValue={this.props.fieldValues.contact_add} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Nationality<span className="text-danger">*</span></label>
                                            <select ref="nationality" required className="form-control" defaultValue={this.props.fieldValues.nationality}>
                                                <option value="" hidden>Select...</option>
                                                {this.nationalities.map((data, i) => {
                                                    return <option key={i} value={data}>{data}</option>
                                                })}
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Country<span className="text-danger">*</span></label>
                                            <select ref="country" required className="form-control" defaultValue={this.props.fieldValues.country} onChange={this.selectCountry}>
                                                <option value="" hidden>Select...</option>
                                                {this.countries.map((data, i) => {
                                                    return <option key={i} value={data.name}>{data.name}</option>
                                                })}
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>State of Origin<span className="text-danger">*</span></label>
                                            <select ref="state_of_origin" required className="form-control" defaultValue={this.props.fieldValues.state_of_origin}>
                                                <option value="" hidden>Select...</option>
                                                {this.state.states.map((data, i) => {
                                                    return <option key={i} value={data.name}>{data.name}</option>
                                                })}
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>City/LGA<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="city_lga" placeholder="City/LGA" defaultValue={this.props.fieldValues.city_lga} required />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div >
                    </div >
                </div >
            </div>
        )
    }
}

export default OtherInfo;